export default __webpack_public_path__ + "static/media/dnsLogo.65ba43bf.svg";